"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6174],{

/***/ 982226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(208984);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth || "")};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 134128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(425336);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);



const Skeleton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Shape */ .b)`
  @keyframes loading {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  background-color: rgba(122, 121, 121, 0.11);
  -webkit-animation: loading 1.5s ease-in-out 0.5s infinite;
  animation: loading 1.5s ease-in-out 0.5s infinite;
  border-radius: 5px;
`;




/***/ }),

/***/ 14766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FacebookComment; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(134128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _useFacebook_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(724656);




const FacebookComment = ({
  href,
  numPosts,
  width,
  appId,
  language,
  colorScheme,
  mobile,
  lazy
}) => {
  const { available, fb, xfbmlParse } = (0,_useFacebook_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useFacebookSDK */ .c)(appId, language);
  const [xfbmlRender, setRender] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!fb || !available)
      return;
    setRender(false);
    if (ref.current) {
      ref.current.style.height = "1px";
    }
    xfbmlParse();
    fb.Event.subscribe("xfbml.render", () => {
      setRender(true);
      if (ref.current) {
        ref.current.style.height = "auto";
      }
    });
    return () => {
      fb.Event.unsubscribe("xfbml.render", () => {
        setRender(false);
      });
    };
  }, [fb, href, numPosts, available]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, available ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !xfbmlRender && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FacebookCommentSkeleton, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    ref
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fb-comments",
    "data-href": href,
    "data-numposts": numPosts,
    "data-width": width,
    "data-lazy": lazy,
    "data-mobile": mobile,
    "data-colorscheme": colorScheme
  }))) : null);
};
FacebookComment.displayName = "FacebookComment";
FacebookComment.defaultProps = {
  width: "100%",
  numPosts: 5,
  colorScheme: "light",
  mobile: "auto-detect",
  lazy: true
};
const FacebookCommentSkeleton = () => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
    padding: "s8"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: "0.5rem",
    marginBottom: "s36",
    padding: ["s8", "s0"]
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: 1,
    marginBottom: "s24"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: "4rem",
    width: "100%",
    marginBottom: "s16"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  overflow: hidden;
`;




/***/ }),

/***/ 724656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useFacebookSDK; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const useFacebookSDK = (appId, language = "vi") => {
  const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  const [available, setAvailable] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _a;
    if (typeof window === "undefined")
      return;
    if (typeof FB != "undefined" && ((_a = window == null ? void 0 : window.fbAsyncInit) == null ? void 0 : _a.hasRun)) {
      setAvailable(true);
      setLoading(false);
      return;
    }
    initializeFacebook(appId, language).catch(() => setAvailable(false)).then(() => {
    }).finally(() => setLoading(false));
  }, [appId, language]);
  const xfbmlParse = () => {
    if (typeof window === "undefined")
      return;
    if (window == null ? void 0 : window.FB) {
      window.FB.XFBML.parse();
    }
  };
  const fb = typeof window !== "undefined" ? window == null ? void 0 : window.FB : void 0;
  return { loading, available, fb, xfbmlParse };
};
const initializeFacebook = async (appId, language) => {
  return new Promise((resolve) => {
    (function(d, s, id) {
      var _a;
      if (d.getElementById(id)) {
        resolve(true);
      }
      const fjs = d.getElementsByTagName(s)[0];
      const js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = `https://connect.facebook.net/${language === "en" ? "en_US" : "vi_VN"}/sdk.js#xfbml=1&version=v16.0&appId=${appId}&autoLogAppEvents=1&status=1&cookie=1`;
      js.defer = true;
      (_a = fjs.parentNode) == null ? void 0 : _a.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};




/***/ }),

/***/ 606174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ DetailPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _tekface_smart_activation__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(560327);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(955006);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(329944);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(431529);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(488924);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(493460);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(842918);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(414562);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(14766);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77322);
/* harmony import */ var _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(184019);
/* harmony import */ var components_LazyComponent__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(110413);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(243290);
/* harmony import */ var components_RelatedVideosAndPosts__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(192719);
/* harmony import */ var components_WishlistButton__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(288257);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(185081);
/* harmony import */ var constants_smartBanner__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(124177);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(723357);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(684443);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(391547);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(504133);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(788813);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(353632);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(770353);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var modules_product_detail_shared_ReviewSection__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(555082);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(891987);
/* harmony import */ var reflexbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(504545);
/* harmony import */ var _shared_MetaData__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(708648);
/* harmony import */ var _ShareButtons__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(439764);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 50%;\n  left: 8px;\n  right: auto;\n  z-index: 1030;\n  cursor: pointer;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  transform: translateY(-50%);\n  background-color: rgba(168, 168, 168, 0.46);\n  border-top-right-radius: 100px;\n  border-bottom-right-radius: 100px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


























const Policies = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(63428), __webpack_require__.e(3349)]).then(__webpack_require__.bind(__webpack_require__, 796537)).then((mod)=>mod.Policies), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(796537)
            ]
    }
});
const ProductRelatedPromotions = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 63505).then(__webpack_require__.bind(__webpack_require__, 463505)).then((mod)=>mod.ProductRelatedPromotions), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(463505)
            ]
    }
});
const ProductCombo = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(53594), __webpack_require__.e(33572), __webpack_require__.e(88099), __webpack_require__.e(50343), __webpack_require__.e(67777), __webpack_require__.e(85881)]).then(__webpack_require__.bind(__webpack_require__, 695133)).then((mod)=>mod.ProductCombo), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(695133)
            ]
    }
});
const ProductHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 70771).then(__webpack_require__.bind(__webpack_require__, 170771)).then((mod)=>mod.ProductHeader), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(170771)
            ]
    }
});
const ActionButtons = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 19947).then(__webpack_require__.bind(__webpack_require__, 619947)).then((mod)=>mod.ActionButtons), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(619947)
            ]
    }
});
const ProductImages = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 52348).then(__webpack_require__.bind(__webpack_require__, 552348)).then((mod)=>mod.ProductImages), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(552348)
            ]
    }
});
const ProductVariants = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 37544).then(__webpack_require__.bind(__webpack_require__, 837544)).then((mod)=>mod.ProductVariants), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(837544)
            ]
    }
});
const PriceAtLocationPicker = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 77123).then(__webpack_require__.bind(__webpack_require__, 177123)).then((mod)=>mod.PriceAtLocationPicker), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(177123)
            ]
    }
});
const ProductSpecifications = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 47417).then(__webpack_require__.bind(__webpack_require__, 847417)).then((mod)=>mod.ProductSpecifications), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(847417)
            ]
    }
});
const Description = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 143).then(__webpack_require__.bind(__webpack_require__, 100143)).then((mod)=>mod.ProductDescription), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(100143)
            ]
    }
});
const ProductPriceAndPromotion = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(83576), __webpack_require__.e(45605)]).then(__webpack_require__.bind(__webpack_require__, 945605)).then((mod)=>mod.ProductPriceAndPromotion), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(945605)
            ]
    }
});
const ConfirmOver18YearOldModal = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(76698), __webpack_require__.e(23540), __webpack_require__.e(58098)]).then(__webpack_require__.bind(__webpack_require__, 923540)).then((mod)=>mod.ConfirmOver18YearOldModal), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(923540)
            ]
    }
});
const FAQSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 65458).then(__webpack_require__.bind(__webpack_require__, 565458)).then((mod)=>mod.FAQSection), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(565458)
            ]
    }
});
const NewReviewSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(76414), __webpack_require__.e(22295), __webpack_require__.e(44303), __webpack_require__.e(15292), __webpack_require__.e(87174)]).then(__webpack_require__.bind(__webpack_require__, 715292)).then((mod)=>mod.ReviewSection), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(715292)
            ]
    }
});
const renderFlashSaleBadge = (total, sold, stock, endAt)=>{
    const remain = Math.min(total - sold, stock);
    const message = sold / total > 0.9 || remain < 5 ? (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Sắp ch\xe1y h\xe0ng") : (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("C\xf2n lại {{remain}}", {
        remain: remain
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__/* .FlashSaleBar */ .P, {
        endAt: new Date(endAt),
        text: message,
        margin: [
            "s16",
            "s0"
        ],
        padding: "s8"
    });
};
const DetailPage = (param)=>{
    let { showRelatedPromotion =true , extraPromotions =[]  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const { flags  } = (0,contexts__WEBPACK_IMPORTED_MODULE_10__/* .useFeatureFlags */ .g)();
    const specificationRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const { product , stockAvailable , showFlashSale , primitiveProduct , relatedProducts , showPopupCheckAge , setShowPopupCheckAge , breadcrumbs , inlineBanners ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_11__/* .useProductDetailState */ .W)();
    const { allowCommentAndReceiveReply , currentLanguage , addSchemaBreadcrumbList , baseDomain , showDetailPageGoBackArrow , epicOmni1550 ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_12__/* .useTenantConfig */ .Wx)();
    const { asPath , back  } = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const flashSaleBadge = showFlashSale && (product === null || product === void 0 ? void 0 : product.flashSale) && stockAvailable ? renderFlashSaleBadge(product.flashSale.total, product.flashSale.used, stockAvailable, product.flashSale.endAt) : null;
    (0,hooks__WEBPACK_IMPORTED_MODULE_13__/* .useIdentifiedPage */ .w)("productDetail");
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        if (product) {
            var ref, ref1, ref2, ref3;
            (0,helpers__WEBPACK_IMPORTED_MODULE_14__/* .saveRecentlyProduct */ .l3)(product.sku, constants_index__WEBPACK_IMPORTED_MODULE_15__/* .RECENTLY_VIEWED_PRODUCTS_KEY */ ._V);
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_16__/* .trackViewProductDetail */ .g)({
                price: (ref = product.price) === null || ref === void 0 ? void 0 : ref.price,
                name: product.name,
                sku: product.sku,
                brand: (ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.name,
                category: ((ref2 = product.categories) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name) || "",
                sellerSku: product === null || product === void 0 ? void 0 : product.sellerSku
            });
        }
    }, [
        product === null || product === void 0 ? void 0 : product.sku
    ]);
    const scrollToSpecification = ()=>{
        var ref;
        (ref = specificationRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    if (!product) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .NotFoundProductLayout */ .DH, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_18__/* .NoProductsFound */ .H, {
                show: true,
                text: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Kh\xf4ng t\xecm thấy sản phẩm")
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !!addSchemaBreadcrumbList && !!(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            itemListElement: breadcrumbs.map((param, index)=>{
                                let { name , link , isLast  } = param;
                                return {
                                    "@type": "ListItem",
                                    position: index + 1,
                                    item: {
                                        name: !index ? (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Trang chủ") : name,
                                        "@id": link === "#" || !!isLast ? "".concat(baseDomain).concat(asPath) : "".concat(baseDomain).concat(link)
                                    }
                                };
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_MetaData__WEBPACK_IMPORTED_MODULE_19__/* .MetaData */ .U, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__/* .Container */ .W, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .Wrapper */ .im, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__/* .Breadcrumbs */ .O, {
                            breadcrumbs: breadcrumbs || []
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                            marginBottom: 24,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                    width: "75.6%",
                                    marginRight: 16,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .Card */ .Zb, {
                                        style: {
                                            padding: "24px",
                                            height: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                                    width: "40.5%",
                                                    paddingRight: 16,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductImages, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Divider */ .i, {
                                                            dividerStyle: _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .DividerStyleEnum.dashed */ .fd.dashed,
                                                            margin: [
                                                                "s12",
                                                                "s0"
                                                            ],
                                                            color: "divider"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .Content */ .VY, {
                                                            dangerouslySetInnerHTML: {
                                                                __html: (dompurify__WEBPACK_IMPORTED_MODULE_2___default()) === null || (dompurify__WEBPACK_IMPORTED_MODULE_2___default()) === void 0 ? void 0 : (ref1 = (dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize)) === null || ref1 === void 0 ? void 0 : ref1.call((dompurify__WEBPACK_IMPORTED_MODULE_2___default()), (product === null || product === void 0 ? void 0 : (ref = product.seoInfo) === null || ref === void 0 ? void 0 : ref.shortDescription) || "")
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_23__/* .Button */ .z, {
                                                            variant: "link",
                                                            onClick: scrollToSpecification,
                                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Xem th\xf4ng tin chi tiết")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ShareButtons__WEBPACK_IMPORTED_MODULE_24__/* .ShareButtons */ .n, {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                                                                    marginTop: 12,
                                                                    marginLeft: 12,
                                                                    alignItems: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_25__/* .Body */ .uT, {
                                                                            level: 1,
                                                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Y\xeau th\xedch ")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WishlistButton__WEBPACK_IMPORTED_MODULE_26__/* .WishlistButton */ .s, {
                                                                            sku: product.sku
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                                    width: "59.5%",
                                                    children: [
                                                        flashSaleBadge,
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductHeader, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .ProductVariantsWrapper */ .W, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductVariants, {})
                                                        }),
                                                        (flags === null || flags === void 0 ? void 0 : flags.epic_ecom_284) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PriceAtLocationPicker, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductPriceAndPromotion, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActionButtons, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_27__/* .BannerInlinePlaceholder */ .Q, {
                                                            banners: inlineBanners,
                                                            className: constants_smartBanner__WEBPACK_IMPORTED_MODULE_28__/* .INLINE_BANNER_CLASSNAME.INLINE_PDP_RELATEDPROMO */ .h.INLINE_PDP_RELATEDPROMO
                                                        }),
                                                        showRelatedPromotion && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductRelatedPromotions, {
                                                            extraPromotions: extraPromotions
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "productAfterPromoBox"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                    width: "24.4%",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Policies, {
                                            wrapperProps: {
                                                itemVerticalSpacing: "s16"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_27__/* .BannerInlinePlaceholder */ .Q, {
                                            banners: inlineBanners,
                                            className: constants_smartBanner__WEBPACK_IMPORTED_MODULE_28__/* .INLINE_BANNER_CLASSNAME.INLINE_PDP_SERVICE */ .h.INLINE_PDP_SERVICE
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                            marginBottom: 24,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                width: "75.6%",
                                marginRight: 16,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCombo, {})
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_LazyComponent__WEBPACK_IMPORTED_MODULE_29__/* .LazyComponent */ .c, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_30__/* .Flex */ .k, {
                                    marginBottom: "s24",
                                    gap: "s16",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .DescriptionCol */ .Ag, {
                                            height: "100%",
                                            width: "calc((100% - 16px)/3 * 2)",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Description, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_31__/* .Col */ .JX, {
                                            ref: specificationRef,
                                            width: "calc((100% - 16px)/3)",
                                            height: "100%",
                                            style: {
                                                scrollMarginTop: "137px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductSpecifications, {}),
                                                (!!((ref2 = product.seoInfo) === null || ref2 === void 0 ? void 0 : ref2.relatedVideos) || !!((ref3 = product.seoInfo) === null || ref3 === void 0 ? void 0 : ref3.relatedPosts)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RelatedVideosAndPosts__WEBPACK_IMPORTED_MODULE_32__/* .RelateVideosAndPosts */ .T, {
                                                    relatedVideos: (ref4 = product.seoInfo) === null || ref4 === void 0 ? void 0 : ref4.relatedVideos,
                                                    relatedPosts: (ref5 = product.seoInfo) === null || ref5 === void 0 ? void 0 : ref5.relatedPosts
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                epicOmni1550 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewReviewSection, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_product_detail_shared_ReviewSection__WEBPACK_IMPORTED_MODULE_33__/* .ReviewSection */ .g, {
                                    product: product
                                })
                            ]
                        }),
                        !!((ref6 = product.seoInfo) === null || ref6 === void 0 ? void 0 : ref6.faq) && product.seoInfo.faq.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQSection, {
                            faq: ((ref7 = product.seoInfo) === null || ref7 === void 0 ? void 0 : ref7.faq) || [],
                            style: {
                                padding: "0px",
                                width: "100%"
                            }
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_LazyComponent__WEBPACK_IMPORTED_MODULE_29__/* .LazyComponent */ .c, {
                            children: relatedProducts.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_17__/* .Card */ .Zb, {
                                style: {
                                    marginBottom: "24px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_34__/* .BlockHeader */ .t, {
                                            title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Sản phẩm li\xean quan")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_35__/* .ProductCarousel */ .G, {
                                            products: relatedProducts,
                                            productsPerRow: 5,
                                            regionName: "relatedProducts",
                                            virtual: (0,helpers__WEBPACK_IMPORTED_MODULE_36__/* .isServerless */ .ep)()
                                        })
                                    ]
                                })
                            }) : null
                        }),
                        allowCommentAndReceiveReply && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_LazyComponent__WEBPACK_IMPORTED_MODULE_29__/* .LazyComponent */ .c, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCommentWrapper, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_37__/* .FacebookComment */ .F, {
                                    appId: (0,helpers__WEBPACK_IMPORTED_MODULE_38__/* .getEnv */ .dU)("NEXT_PUBLIC_FACEBOOK_APP_ID"),
                                    language: currentLanguage,
                                    href: "".concat((0,helpers__WEBPACK_IMPORTED_MODULE_14__/* .getBaseDomain */ .xq)(), "/").concat(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref8 = primitiveProduct.productInfo) === null || ref8 === void 0 ? void 0 : ref8.canonical)
                                })
                            })
                        })
                    ]
                })
            }),
            showPopupCheckAge !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConfirmOver18YearOldModal, {
                showPopupCheckAge: showPopupCheckAge,
                setShowPopupCheckAge: setShowPopupCheckAge
            }),
            !!showDetailPageGoBackArrow && (0,helpers__WEBPACK_IMPORTED_MODULE_36__/* .isServerless */ .ep)() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_39__/* .BackOutlined */ .Y, {
                    size: 30,
                    color: "#333",
                    onClick: ()=>{
                        back();
                    }
                })
            })
        ]
    });
};
const ProductCommentWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_40__["default"].div(_templateObject());
const IconWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_40__["default"].div(_templateObject1());


/***/ }),

/***/ 439764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ ShareButtons; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/MessengerColored.es.js
var MessengerColored_es = __webpack_require__(876856);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/FacebookFilled.es.js
var FacebookFilled_es = __webpack_require__(178504);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/LinkOutlined.es.js
var LinkOutlined_es = __webpack_require__(188543);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./assets/zalo-logo.svg
var zalo_logo = __webpack_require__(434883);
;// CONCATENATED MODULE: ./components/desktop/organisms/ZaloShareButton.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(",
        ");\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




const ZaloShareButton = (param)=>{
    let { url , size ="26" , zaloOAId ,  } = param;
    (0,react.useEffect)(()=>{
        // Gọi reload để init lại widget nếu cần
        if ( true && window.ZaloSocialSDK) {
            window.ZaloSocialSDK.reload();
        }
    }, [
        url
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledZaloIcon, {
        className: "zalo-share-button",
        "data-href": url,
        "data-oaid": zaloOAId,
        "data-customize": true,
        size: size
    });
};
const StyledZaloIcon = emotion_styled_browser_esm["default"].div(_templateObject(), (prop)=>prop.size, (prop)=>prop.size, zalo_logo/* default */.Z);

// EXTERNAL MODULE: ./contexts/ToastContext.tsx
var ToastContext = __webpack_require__(508285);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPage/ShareButtons.tsx
function ShareButtons_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ShareButtons_templateObject() {
    const data = ShareButtons_taggedTemplateLiteral([
        "\n  -webkit-transform: rotate(135deg);\n  -moz-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  -o-transform: rotate(135deg);\n  transform: rotate(135deg);\n  cursor: pointer;\n"
    ]);
    ShareButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = ShareButtons_taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  background-color: #52c41a;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








const ShareButtons = ()=>{
    const toast = (0,ToastContext/* useToast */.p)();
    const { getProcessEnv , zaloOAId  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const router = (0,next_router.useRouter)();
    const { 0: zaloShareUrl , 1: setzaloShareUrl  } = (0,react.useState)("");
    const copyCurrentUrl = async ()=>{
        var ref, ref1;
        if (typeof navigator === "undefined" || "object" === "undefined" || !navigator || !((ref = window.location) === null || ref === void 0 ? void 0 : ref.href)) {
            return;
        }
        await navigator.clipboard.writeText(window.location.href);
        (ref1 = toast.success) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
            title: null,
            message: (0,i18n.t)("Đ\xe3 sao ch\xe9p đường dẫn")
        });
    };
    const shareFacebook = ()=>{
        var ref;
        if ( false || !((ref = window.location) === null || ref === void 0 ? void 0 : ref.href)) return;
        window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(window.location.href)), "new-window", "status = 1, width=".concat(window.screen.width / 2, ", height=").concat(window.screen.height / 2, ", top=").concat(window.screen.height / 4, ", \n      left=").concat(window.screen.width / 4, ", scrollbars=no"));
    };
    const shareMessenger = ()=>{
        var ref;
        if ( false || !((ref = window.location) === null || ref === void 0 ? void 0 : ref.href)) return;
        window.open("http://www.facebook.com/dialog/send?app_id=".concat(getProcessEnv("NEXT_PUBLIC_FB_APP_ID"), "&link=").concat(encodeURIComponent(window.location.href), "&redirect_uri=").concat(encodeURIComponent(window.location.href)), "new-window", "status = 1, width=".concat(window.screen.width / 2, ", height=").concat(window.screen.height / 2, ", top=").concat(window.screen.height / 4, ", \n      left=").concat(window.screen.width / 4, ", scrollbars=no"));
    };
    //set zaloShareUrl
    (0,react.useEffect)(()=>{
        if (true) {
            const fullUrl = window.location.origin + router.asPath;
            setzaloShareUrl(fullUrl);
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
        gap: "s8",
        marginTop: "s12",
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                level: 1,
                children: [
                    (0,i18n.t)("Chia sẻ"),
                    ": "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                gap: "s4",
                align: "center",
                justify: "center",
                children: [
                    !!zaloShareUrl && !!zaloOAId && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        height: "24px",
                        width: "24px",
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ZaloShareButton, {
                            url: zaloShareUrl,
                            zaloOAId: zaloOAId,
                            size: "18"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerColored_es/* MessengerColored */.q, {
                        onClick: shareMessenger,
                        size: "24",
                        style: {
                            cursor: "pointer"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        height: "24px",
                        width: "24px",
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookFilled_es/* FacebookFilled */.J, {
                            onClick: shareFacebook,
                            size: "20",
                            style: {
                                cursor: "pointer"
                            },
                            color: "#0958D9"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        height: "24px",
                        width: "24px",
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOutlinedWrapper, {
                            height: "16px",
                            width: "16px",
                            onClick: copyCurrentUrl,
                            align: "center",
                            justify: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkOutlined, {
                                color: "white",
                                size: "14"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const StyledLinkOutlined = (0,emotion_styled_browser_esm["default"])(LinkOutlined_es/* LinkOutlined */.Z)(ShareButtons_templateObject());
const LinkOutlinedWrapper = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject1());


/***/ }),

/***/ 434883:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ("data:image/svg+xml;base64,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");

/***/ })

}]);